
// TYPES
export const types = {
    ADD_ITEM: "CART/ADD_ITEM",
    ADD_QUANTITY: "CART/ADD_QUANTITY",
    SUBTRACT_QUANTITY: "CART/SUBTRACT_QUANTITY",
    REMOVE_ITEM: "CART/REMOVE_ITEM",
    CLEAR_ALL: "CART/CLEAR_ALL"
};

// INITIAL STATE
export const initialState = {
    items: []
};

// REDUCER
export default (state = initialState, action) => {
    switch (action.type) {
        case types.ADD_ITEM:
            return {
                ...state,
                items: [...state.items, action.payload]
            };

        case types.ADD_QUANTITY:
            return {
                ...state,
                items: state.items.map((item, index) => {
                    if(index !== action.payload) {
                        return item;
                    }

                    return {
                        ...item,
                        quantity: parseInt(item.quantity + 1)
                    }
                })
            };

        case types.SUBTRACT_QUANTITY:
            return {
                ...state,
                items: state.items.map((item, index) => {
                    if(index !== action.payload) {
                        return item;
                    }

                    return {
                        ...item,
                        quantity: parseInt(item.quantity - 1)
                    }
                })
            };
        case types.REMOVE_ITEM:
            return {
                ...state,
                items: state.items.filter((item ,index) => {
                    return index !== action.payload
                })
            };
        case types.CLEAR_ALL:
            return {
                ...state,
                items: []
            };

        default:
            return state
    }
}

// ACTIONS
export const actions = {

    addItem: (item) => {
        return {
            type: types.ADD_ITEM,
            payload: item
        };
    },

    removeItem: (index) => {
        return {
            type: types.REMOVE_ITEM,
            payload: index
        }
    },

    addQuantity: (index) => {
        return {
            type: types.ADD_QUANTITY,
            payload: index
        }
    },

    subtractQuantity: (index) => {
        return {
            type: types.SUBTRACT_QUANTITY,
            payload: index
        }
    },

    clearAll: () => {
        return {
            type: types.CLEAR_ALL
        }
    }
};


// WEBPACK FOOTER //
// ./src/redux/modules/Cart.js